module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//23.jpg?6c829bad54200b8e7316e4939b8792d8";